<app-main-layout [clickBack]="onClickBack" [disableWatchingRoutes]="true">
  <div class="block">
    <div class="main-heading">
      @if (brandKey === 'newsouth' || brandKey === 'armorvue') {
        <h2>We look forward to speaking with you soon. In the meantime, here are a few helpful next steps.</h2>
      } @else {
        <h2>We're looking forward to talking with you soon! In the meantime, here are a few things to help you get started.</h2>
      }
    </div>
  </div>
  @if (blogPosts) {
    <div class="blog-posts-frame wide">
      @for (card of blogPosts; track card) {
        <app-blog-post-card [card]="card" />
      }
    </div>
  }
</app-main-layout>
